import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { PetsListResponse, PetsList } from '../types';
type UseBusinessOptions = {
  businessId?: number;
  startDate?: Date;
  endDate?: Date;
  page: number;
  perPage: number;
  isPast?: boolean;
  petTypes?: string[];
};
export const getPetsList = (
  { businessId, startDate, endDate, page, perPage, isPast, petTypes }: UseBusinessOptions = {
    page: 1,
    perPage: 10,
    petTypes: [],
  }
): Promise<PetsListResponse> => {
  return axios.get( `/parent/pets/list`,
    {
      params: {  page, perPage, petType:petTypes && petTypes.length > 0 ? petTypes.toString() : undefined },
    }
  );
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getPetsList>;
};

export const useGetPetsList = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getPetsList,
  });
};
